import _ from "lodash";

import { float6Normalizer } from "validators";

export const errMapper = (formName, dispatch, change, feeTemplate) => {
	const findErrMapperFormValue = _.filter(
		feeTemplate.fieldBlocks,
		item => item.name === "ERR",
	);

	if (_.isEmpty(findErrMapperFormValue)) return;

	const findErrAuthorizationFeeValue = _.find(
		findErrMapperFormValue[0]?.fields,
		{
			name: "errAuthorizationFee",
		},
	);

	const findErrSalesTransactionFeeValue = _.find(
		findErrMapperFormValue[0]?.fields,
		{
			name: "errSalesTransactionFee",
		},
	);

	const findErrQualVMCDValue = _.find(findErrMapperFormValue[0]?.fields, {
		name: "errQualVMCD",
	});

	const findErrNonQualVMCDValue = _.find(findErrMapperFormValue[0]?.fields, {
		name: "errNonQualVMCD",
	});

	const findErrQualAmexValue = _.find(findErrMapperFormValue[0]?.fields, {
		name: "errQualAmex",
	});

	const findErrNonQualAmexValue = _.find(findErrMapperFormValue[0]?.fields, {
		name: "errNonQualAmex",
	});

	const findErrQualOfflineDebitValue = _.find(
		findErrMapperFormValue[0]?.fields,
		{
			name: "errQualOfflineDebit",
		},
	);

	const findErrNonQualOfflineDebitValue = _.find(
		findErrMapperFormValue[0]?.fields,
		{
			name: "errNonQualOfflineDebit",
		},
	);

	const findPassCardBrandFeesValue = _.find(
		findErrMapperFormValue[0].fields,
		{
			name: "passCardBrandFees",
		},
	);

	dispatch(
		change(
			formName,
			"errAuthorizationFee",
			float6Normalizer(findErrAuthorizationFeeValue?.value),
		),
	);

	dispatch(
		change(
			formName,
			"errSalesTransactionFee",
			float6Normalizer(findErrSalesTransactionFeeValue?.value),
		),
	);

	dispatch(
		change(
			formName,
			"errQualVMCD",
			float6Normalizer(findErrQualVMCDValue.value),
		),
	);

	dispatch(
		change(
			formName,
			"errNonQualVMCD",
			float6Normalizer(findErrNonQualVMCDValue.value),
		),
	);

	dispatch(
		change(
			formName,
			"errQualAmex",
			float6Normalizer(findErrQualAmexValue.value),
		),
	);

	dispatch(
		change(
			formName,
			"errNonQualAmex",
			float6Normalizer(findErrNonQualAmexValue.value),
		),
	);

	dispatch(
		change(
			formName,
			"errQualOfflineDebit",
			float6Normalizer(findErrQualOfflineDebitValue.value),
		),
	);

	dispatch(
		change(
			formName,
			"errNonQualOfflineDebit",
			float6Normalizer(findErrNonQualOfflineDebitValue.value),
		),
	);

	dispatch(
		change(
			formName,
			"errNonQualOfflineDebit",
			float6Normalizer(findErrNonQualOfflineDebitValue.value),
		),
	);

	dispatch(
		change(formName, "passCardBrandFees", findPassCardBrandFeesValue.value),
	);
};
